import React, { Component, Fragment } from 'react';
import Preloader from './preloader';
import Select from './select';
import CurrentWeather from './currentWeather';
import ForecastWeather from './forecastWeather';
import Error from './errorPage';

class App extends Component {
    render() {
        return (
            <Fragment>
                <Preloader/>
                <div className='container'>
                    <div id="weather-content">
                        <div className="card text-white bg-primary mt-3 pb-3">
                            <div className="d-flex flex-sm-row flex-column justify-content-center mt-3 mb-3">
                                <h5 className="card-title text-center">Погода в городах Украины</h5>
                                <Select/>
                            </div>
                            <CurrentWeather/>
                        </div>
                        <div id="forecast-weather" className='mt-3'>
                            <ForecastWeather/>
                        </div>
                    </div>
                </div>
                <Error/>
            </Fragment>
        );
    }
}

export default App;